import {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  FC,
  ReactNode,
} from 'react';
import { cn } from '../../utils';

interface PaginationControls extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  children: ReactNode;
  active?: boolean;
  disabled?: boolean;
  page: number;
}

export const PaginationLink: FC<PaginationControls> = ({
  children,
  className,
  page,
  active,
  disabled,
  ...props
}) => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('page', page.toString());

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    window.history.pushState({}, '', currentUrl.toString());
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <li aria-disabled={disabled} className={className}>
      <a
        href={currentUrl.toString()}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && disabled) {
            event.preventDefault();
          }
        }}
        aria-disabled={disabled}
        className={cn('l-btn l-btn-sm l-btn-tertiary', {
          'bg-neutral-200': active,
          'pointer-events-none': disabled,
        })}
        {...props}
        onClick={handleClick}
      >
        {children}
      </a>
    </li>
  );
};

interface IPaginationButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: ReactNode;
  active?: boolean;
  disabled?: boolean;
  page: number;
}

export const PaginationButton: FC<IPaginationButton> = ({
  children,
  className,
  active,
  disabled,
  ...props
}) => {
  return (
    <li aria-disabled={disabled} className={className}>
      <button
        disabled={disabled}
        className={cn('l-btn l-btn-sm l-btn-tertiary', {
          'bg-neutral-200': active,
          'pointer-events-none': disabled,
        })}
        {...props}
      >
        {children}
      </button>
    </li>
  );
};
